import { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import NotificationToaste from "./scenes/global/NotificationToaste";
import ConcreteReport from "./scenes/concreteReport/ConcreteReport";
import Institutes from "./scenes/institutes/Institutes";
import SearOrganizer from "./scenes/seatorganizer/SearOrganizer";
import Test from "./scenes/seatorganizer/Test";
import NewJob from "./scenes/newJob/NewJob";
import { Payments } from "./scenes/payment/Payments";
import ReqInvoice from "./scenes/payment/ReqInvoice";
import NewTest from "./scenes/labTests/NewTest";
import NewJobRequest from "./scenes/newJob/NewJobRequest";
import ApproveJob from "./scenes/approveJobs/ApproveJob";
import UserRegistration from "./scenes/userAuthentication/UserRegistration";
import JobRequestPayment from "./scenes/payment/JobRequestPayment";
import RequestPayment from "./scenes/payment/RequestPayment";
import ToPanel from "./scenes/toPanel/ToPanel";
import ComExpenses from "./scenes/expenses/ComExpenses";
import AnnualReports from "./scenes/dashboardCharts/reports/AnnualReports";
import JobAuthorize from "./scenes/authorizedReports/JobAuthorize";
import TrackJob from "./scenes/trackjob/TrackJob";
import TechnicalOfficer from "./scenes/technicalOfficer/TechnicalOfficer";
import PDFViewer from "./scenes/jasperReports/PDFViewer";
import NotificationCenter from "./components/NotificationCenter";
import WhatsAppOpener from "./components/WhatsAppOpener";
import JobAuthorizeCommon from "./scenes/authorizedReports/JobAuthorizeCommon";
import EmailForm from "./scenes/sendEmail/EmailForm";
import LabRequestProgress from "./scenes/progress/LabRequestProgress";
import DashboardProgress from "./Dashboard/Dashboard";
import { dbData } from "./DBData";
import LabRequestCalendar from "./scenes/newJob/LabRequestCalendar";
import AuthorizedJobsOnly from "./scenes/authorizedReports/AuthorizedJobsOnly";
import VehicleManagement from "./scenes/vehicleManagement/VehicleManagement";
import VehicleBooking from "./scenes/vehicleManagement/VehicleBooking";
import DashboardProgressNew from "./Dashboard/DashboardProgressNew";

// Create a wrapper component for authenticated routes

// Main App component
export function HomeContent({ onLogout, user, selected, setSelected }) {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [userNotification, setUserNotification] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [refreshDashboard, setRefreshDashboard] = useState(false);

  const jsonData = dbData;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar
            isSidebar={isSidebar}
            selected={selected}
            setSelected={setSelected}
            loggedUser={user}
          />
          <main className="content">
            <Topbar
              userNotification={userNotification}
              notificationCount={notificationCount}
              setUserNotification={setUserNotification}
              setIsSidebar={setIsSidebar}
              setRefreshDashboard={setRefreshDashboard}
              onLogout={onLogout}
              user={user}
            />
            <Routes>
              <Route
                path="/"
                element={
                  <DashboardProgressNew
                    userNotification={userNotification}
                    setUserNotification={setUserNotification}
                    setNotificationCount={setNotificationCount}
                    refreshDashboard={refreshDashboard}
                    loggedUser={user}
                    onLogout={onLogout}
                  />
                }
              />
              <Route
                path="/dashboardOld"
                element={
                  <Dashboard
                    userNotification={userNotification}
                    setUserNotification={setUserNotification}
                    setNotificationCount={setNotificationCount}
                    refreshDashboard={refreshDashboard}
                    loggedUser={user}
                    onLogout={onLogout}
                  />
                }
              />
              <Route
                path="/dashboard"
                element={
                  <DashboardProgressNew
                    userNotification={userNotification}
                    setUserNotification={setUserNotification}
                    setNotificationCount={setNotificationCount}
                    refreshDashboard={refreshDashboard}
                    loggedUser={user}
                    onLogout={onLogout}
                  />
                }
              />
              <Route path="/newjob" element={<NewJob />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/form" element={<Form />} />
              <Route path="/bar" element={<Bar />} />
              <Route path="/pie" element={<Pie />} />
              <Route path="/line" element={<Line />} />
              <Route path="/newJobReq" element={<NewJobRequest />} />
              <Route path="/concreteReport" element={<ConcreteReport />} />
              <Route path="/institutes" element={<Institutes />} />
              <Route path="/users" element={<UserRegistration />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/geography" element={<Geography />} />
              <Route path="/seat" element={<Test />} />
              <Route path="/payment" element={<JobRequestPayment />} />
              <Route path="/invoice" element={<RequestPayment />} />
              <Route path="/newtest" element={<NewTest />} />
              <Route path="/approveJob" element={<ApproveJob />} />
              <Route
                path="/toPanel"
                element={
                  user?.position?.id === 4 ? (
                    <ToPanel loggedUser={user} />
                  ) : user?.position?.id === 2 || user?.position?.id === 3 ? (
                    <TechnicalOfficer loggedUser={user} />
                  ) : (
                    " "
                  )
                }
              />
              <Route path="/expenses" element={<ComExpenses />} />
              <Route path="/reports" element={<AnnualReports />} />
              <Route path="/approve" element={<JobAuthorize />} />
              <Route path="/approveJobEng" element={<AuthorizedJobsOnly />} />
              <Route path="/track" element={<TrackJob />} />
              <Route path="/allReports" element={<JobAuthorizeCommon />} />
              <Route
                path="/vehicleManagement"
                element={<VehicleManagement />}
              />
              <Route path="/vehicleBooking" element={<VehicleBooking />} />
              <Route
                path="/dbprogress"
                element={<DashboardProgress loggedUser={user} />}
              />
              <Route
                path="/jobCalender"
                element={<LabRequestCalendar loggedUser={user} />}
              />
              {/* Catch all route - redirect to dashboard */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </main>
          <NotificationCenter loggerUser={user} />
          {/* <WhatsAppOpener /> */}
          {/* {<EmailForm />} */}
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
